import Glide from '@glidejs/glide';
import $ from 'jquery';
import videojs from 'video.js';

export default class ProjectDetail {
  static mount() {
    $(".cm-projectdetail").each(function () {
      new ProjectDetail($(this));
    });
  }

  constructor($element) {
    this.$element = $element;
    this.$element.data('projectdetail', this);
    this.$glide_container = $element.find(".cm-projectdetail__glide");
    this.scale = 1;
    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.moveX = 0;
    this.moveY = 0;

    this.$glide = new Glide(this.$glide_container[0], {
      type: 'carousel',
      animationDuration: 20,
      startAt: 0,
      perView: 1,
      gap: 100,
      hoverpause: true,
      keyboard: true,
      bound: true,
    });

    this.$glide.on('run.before', () => {
      this.pauseAllVideos();
    });

    this.$glide.on(['swipe.end', 'mount.after'], () => {
      const videosjsElements = $(".video-js", this.$element);
      videosjsElements.each(function () {
        videojs(this);
      });
    });

    // this.$glide.on('run.after', () => {
    //   this.resetZoom();
    // });

    this.$glide.mount();
    this.addDoubleClickZoomFeature();

    // Zoom-Events hinzufügen
    // this.addZoomFeature();
  }

  pauseAllVideos() {
    $('video', this.$element).trigger('pause');
  }

  // resetZoom() {
  //   const currentSlide = this.$glide_container.find('.glide__slide--active img');
  //   currentSlide.css('transform', 'scale(1) translate(0, 0)');
  //   this.$glide_container.removeClass('zoom-active');
  //   this.scale = 1;
  //   this.moveX = 0;
  //   this.moveY = 0;
  //   this.lastMoveX = 0;
  //   this.lastMoveY = 0;
  // }

  // addZoomFeature() {
  //   let isPinching = false;
  //   let initialDistance = 0;
  //   let scale = 1;
  //   let startX = 0;
  //   let startY = 0;
  //   let moveX = 0;
  //   let moveY = 0;
  //   let lastMoveX = 0;
  //   let lastMoveY = 0;
  //   const maxScale = 3;

  //   const getDistance = (touches) => {
  //     const dx = touches[0].clientX - touches[1].clientX;
  //     const dy = touches[0].clientY - touches[1].clientY;
  //     return Math.sqrt(dx * dx + dy * dy);
  //   };

  //   this.$glide_container.on('touchstart', (e) => {
  //     console.log('touchstart');
  //     const currentSlide = this.$glide_container.find('.glide__slide--active img');

  //     if (currentSlide.length && e.touches.length === 2) {
  //       isPinching = true;
  //       initialDistance = getDistance(e.touches);
  //       // this.$glide_container.addClass('zoom-active');
  //       e.preventDefault();
  //     } else if (scale > 1 && e.touches.length === 1) {
  //       startX = e.touches[0].clientX - lastMoveX;
  //       startY = e.touches[0].clientY - lastMoveY;
  //       e.preventDefault();
  //     }
  //   });

  //   this.$glide_container.on('touchmove', (e) => {
  //     const currentSlide = this.$glide_container.find('.glide__slide--active img');
  //     const figure = currentSlide.closest('figure');
  //     const padding = parseInt(figure.css('padding'), 10);

  //     if (isPinching && e.touches.length === 2) {
  //       e.stopPropagation();
  //       e.preventDefault();

  //       const currentDistance = getDistance(e.touches);
  //       const zoomFactor = currentDistance / initialDistance;

  //       scale = Math.min(Math.max(1, zoomFactor), maxScale);
  //       currentSlide.css('transform', `scale(${scale}) translate(${moveX}px, ${moveY}px)`);
  //       currentSlide.css('transform-origin', 'center center');
  //       currentSlide.css('overflow', 'hidden');
  //     } else if (scale > 1 && e.touches.length === 1) {
  //       moveX = e.touches[0].clientX - startX;
  //       moveY = e.touches[0].clientY - startY;

  //       // Begrenze die Verschiebung, um das Padding zu berücksichtigen
  //       const maxMoveX = (currentSlide.width() * (scale - 1)) / 2 - padding;
  //       const maxMoveY = (currentSlide.height() * (scale - 1)) / 2 - padding;

  //       moveX = Math.min(Math.max(moveX, -maxMoveX), maxMoveX);
  //       moveY = Math.min(Math.max(moveY, -maxMoveY), maxMoveY);

  //       lastMoveX = moveX;
  //       lastMoveY = moveY;
  //       currentSlide.css('transform', `scale(${scale}) translate(${moveX}px, ${moveY}px)`);
  //       e.stopPropagation();
  //       e.preventDefault();
  //     }
  //   });

  //   this.$glide_container.on('touchend', () => {
  //     isPinching = false;
  //     if (scale === 1) {
  //       this.$glide_container.removeClass('zoom-active');
  //     }
  //   });
  // }

  addDoubleClickZoomFeature() {
    this.$glide_container.on('dblclick dbltap', (e) => {
      const currentSlide = this.$glide_container.find('.glide__slide--active img');
      
      if (currentSlide.length) {
        if (this.scale === 1) {
          // Zoom aktivieren
          this.scale = 2;
          this.moveX = 0;
          this.moveY = 0;
          
          const zoomWrapper = $('<div class="zoom__wrapper zoom--active"></div>');
          zoomWrapper.css({
            'overflow': 'hidden',
            'position': 'relative',
            'width': '100%',
            'height': '100%'
          });
          
          currentSlide.wrap(zoomWrapper);
          currentSlide.css({
            'transform': `scale(${this.scale}) translate(0, 0)`,
            'transform-origin': 'center center',
            'max-width': 'none',
            'max-height': 'none',
            'cursor': 'grab'
          });
          
          this.$glide.disable();

          // Drag-Events
          currentSlide.on('mousedown touchstart', (e) => {
            this.isDragging = true;
            this.startX = e.pageX || e.originalEvent.touches[0].pageX;
            this.startY = e.pageY || e.originalEvent.touches[0].pageY;
            currentSlide.css('cursor', 'grabbing');
            e.preventDefault();
          });

          $(document).on('mousemove touchmove', (e) => {
            if (!this.isDragging) return;

            const x = e.pageX || e.originalEvent.touches[0].pageX;
            const y = e.pageY || e.originalEvent.touches[0].pageY;
            
            // Berechne die Verschiebung
            const deltaX = x - this.startX;
            const deltaY = y - this.startY;
            
            // Aktualisiere Startposition
            this.startX = x;
            this.startY = y;

            // Berechne neue Position
            const newMoveX = this.moveX + deltaX;
            const newMoveY = this.moveY + deltaY;

            // Berechne Grenzen
            const wrapperWidth = zoomWrapper.width();
            const wrapperHeight = zoomWrapper.height();
            const imageWidth = currentSlide.width() * this.scale;
            const imageHeight = currentSlide.height() * this.scale;

            // Maximale Verschiebung berechnen
            const maxX = Math.max(0, (imageWidth - wrapperWidth) / 2);
            const maxY = Math.max(0, (imageHeight - wrapperHeight) / 2);

            // Begrenze die Verschiebung
            this.moveX = Math.max(-maxX, Math.min(maxX, newMoveX));
            this.moveY = Math.max(-maxY, Math.min(maxY, newMoveY));

            // Wende Transformation an
            currentSlide.css('transform', `scale(${this.scale}) translate(${this.moveX / this.scale}px, ${this.moveY / this.scale}px)`);
          });

          $(document).on('mouseup touchend', () => {
            this.isDragging = false;
            currentSlide.css('cursor', 'grab');
          });

        } else {
          // Zoom deaktivieren
          this.scale = 1;
          this.moveX = 0;
          this.moveY = 0;
          
          const zoomWrapper = currentSlide.closest('.zoom__wrapper');
          currentSlide.unwrap();
          currentSlide.css({
            'transform': 'scale(1) translate(0, 0)',
            'max-width': 'calc(100% - 20px)',
            'max-height': 'calc(100% - 20px)',
            'cursor': 'default'
          });
          
          this.$glide.enable();
          $(document).off('mousemove touchmove');
          $(document).off('mouseup touchend');
          zoomWrapper.remove();
        }
      }
    });
  }
}
